var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { REACT_FLOW_CHART } from '../../';
import CanvasContext from './CanvasContext';
export class CanvasWrapper extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            width: 0,
            height: 0,
            offsetX: 0,
            offsetY: 0,
        };
        this.ref = React.createRef();
        this.updateSize = () => {
            const el = this.ref.current;
            if (el) {
                const rect = el.getBoundingClientRect();
                if (el.offsetWidth !== this.state.width || el.offsetHeight !== this.state.height) {
                    this.setState({ width: el.offsetWidth, height: el.offsetHeight });
                    this.props.onSizeChange(el.offsetWidth, el.offsetHeight);
                }
                if (rect.left !== this.state.offsetX || rect.top !== this.state.offsetY) {
                    this.setState({ offsetX: rect.left, offsetY: rect.top });
                }
            }
        };
    }
    componentDidMount() {
        this.updateSize();
        if (this.ref.current) {
            if (window.ResizeObserver) {
                const ro = new window.ResizeObserver(this.updateSize);
                ro.observe(this.ref.current);
            }
            else {
                window.addEventListener('resize', this.updateSize);
            }
            window.addEventListener('scroll', this.updateSize);
        }
    }
    componentDidUpdate() {
        this.updateSize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSize);
        window.removeEventListener('scroll', this.updateSize);
    }
    render() {
        var _a;
        const { config, ComponentInner, ComponentOuter, position, children, onCanvasClick, onDeleteKey, onCanvasDrop, } = this.props;
        const { offsetX, offsetY, } = this.state;
        const _b = (_a = config.zoomConfig, (_a !== null && _a !== void 0 ? _a : {})), { options: zcOptions, scalePadding: zcScalePadding, wheel: zcWheel, pan: zcPan, zoomIn: zcZoomIn, zoomOut: zcZoomOut } = _b, zcConfig = __rest(_b, ["options", "scalePadding", "wheel", "pan", "zoomIn", "zoomOut"]);
        return (React.createElement(CanvasContext.Provider, { value: { offsetX: this.state.offsetX, offsetY: this.state.offsetY } },
            React.createElement(TransformWrapper, Object.assign({ defaultScale: 1, options: Object.assign({ limitToBounds: false, maxScale: 1.8, minScale: 0.2, centerContent: true }, zcOptions), scalePadding: Object.assign({ animationTime: 120, animationType: 'linear' }, zcScalePadding), wheel: Object.assign({ step: 32 }, zcWheel), pan: Object.assign({ velocity: true }, zcPan), zoomIn: Object.assign({ step: 32, animationTime: 120, animationType: 'linear' }, zcZoomIn), zoomOut: Object.assign({ step: 32, animationTime: 120, animationType: 'linear' }, zcZoomOut) }, zcConfig), ({ resetTransform }) => (React.createElement(ComponentOuter, { ref: this.ref, config: config, onTransformReset: resetTransform },
                React.createElement(TransformComponent, null,
                    React.createElement(ComponentInner, { config: config, children: children, onClick: onCanvasClick, tabIndex: 0, onKeyDown: (e) => {
                            // delete or backspace keys
                            if (e.keyCode === 46 || e.keyCode === 8) {
                                onDeleteKey({ config });
                            }
                        }, onDrop: (e) => {
                            const data = JSON.parse(e.dataTransfer.getData(REACT_FLOW_CHART));
                            if (data) {
                                onCanvasDrop({ data, position: {
                                        x: e.clientX - (position.x + offsetX),
                                        y: e.clientY - (position.y + offsetY),
                                    } });
                            }
                        }, onDragOver: (e) => e.preventDefault() })))))));
    }
}
